import { useState, useCallback } from 'react';

interface UseImageModalReturn {
  isOpen: boolean;
  openModal: (images: string[], title?: string) => void;
  closeModal: () => void;
  modalProps: {
    images: string[];
    title: string;
  };
}

export function useImageModal(): UseImageModalReturn {
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState<string[]>([]);
  const [title, setTitle] = useState('Imagens da oferta');

  const openModal = useCallback((
    modalImages: string[], 
    modalTitle = 'Imagens da oferta'
  ) => {
    setImages(modalImages);
    setTitle(modalTitle);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    openModal,
    closeModal,
    modalProps: { images, title },
  };
}